import React, { Fragment, useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import estilos from '../Zonas/ZonasListComponent.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faCheck,
    faLocation, faPen, faPerson, faTrash
} from '@fortawesome/free-solid-svg-icons'
import LocalidadesDeLaZonaComponent from './LocalidadesDeLaZonaComponent'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { useDispatch } from 'react-redux'
import { eliminarZona, habilitarZona,getZonas } from '../../../redux/DucksUnidadInspeccion/ZonasDuck'
import { useSelector } from 'react-redux'
import LocalidadFormComponent from './LocalidadFormComponent'
import { colorZonaByTipo } from './ZonasUtils/ZonasUtils'
import AsociadoFormComponent from './AsociadoFormComponent'
import AsociadosDeLaLocalidadComponent from './AsociadosDeLaLocalidadComponent'

function ZonasListItemComponent(props) {

    const zona = props.zona.zona
    const dispatch = useDispatch()
    const inspectores = useSelector(store => store.Inspectores.inspectores)
    const id = props.zona.zona.idzona

    const [open, setOpen] = React.useState(false);
    const [localidades, setLocalidades] = React.useState([]);
    const [sublocalidades, setSubLocalidades] = React.useState([]);

    const handleOpen = () => {

        // let localidades = []
        // let sublocalidades = []

        // props.zona.zona.semana.forEach(element => {
        //     element.sublocalidadporsemanaaldia.forEach(element => {
        //         sublocalidades.push(element.sublocalidad)
        //     });
        // });

        // props.zona.zona.semana.forEach(element => {
        //     element.sublocalidadporsemanaaldia.forEach(element => {
        //         localidades.push(element.sublocalidad.localidad)
        //     });
        // });

        // let hash = {};
        // localidades = localidades.filter(o => hash[o.idlocalidad] ? false : hash[o.idlocalidad] = true);

        // let hash2 = {};
        // sublocalidades = sublocalidades.filter(o => hash2[o.idsublocalidad] ? false : hash2[o.idsublocalidad] = true);

        // setLocalidades(localidades)
        // setSubLocalidades(sublocalidades)
        //props.actualizarZonas()
        setOpen(true)
    };

    React.useEffect(() => {
        let localidades = []
        let sublocalidades = []

        props.zona.zona.semana.forEach(element => {
            element.sublocalidadporsemanaaldia.forEach(element => {
                sublocalidades.push(element.sublocalidad)
            });
        });

        props.zona.zona.semana.forEach(element => {
            element.sublocalidadporsemanaaldia.forEach(element => {
                localidades.push(element.sublocalidad.localidad)
            });
        });

        let hash = {};
        localidades = localidades.filter(o => hash[o.idlocalidad] ? false : hash[o.idlocalidad] = true);

        let hash2 = {};
        sublocalidades = sublocalidades.filter(o => hash2[o.idsublocalidad] ? false : hash2[o.idsublocalidad] = true);

        setLocalidades(localidades)
        setSubLocalidades(sublocalidades)
        //props.actualizarZonas()
        //setOpen(true)
    }, [zona])

    const handleClose = () => setOpen(false);

    const [modalBorrarZona, setModalBorrarZona] = React.useState(false);
    const [modalHabilitarZona, setModalHabilitarZona] = React.useState(false);

    const handleAbrirModalBorrarZona = () => {
        setModalBorrarZona(true);
    }
    const handleCerrarModalBorrarZona = () => {
        setModalBorrarZona(false);
    }

    const handleAbrirModalHabilitarZona = () => {
        setModalHabilitarZona(true);
    }
    const handleCerrarModalHabilitarZona = () => {
        setModalHabilitarZona(false);
    }

    const borrarZona = (id) => {
        dispatch(eliminarZona(zona.idzona))
        props.actualizarZonas()
        handleCerrarModalBorrarZona()
    }

    const activarZona = (id) => {
        dispatch(habilitarZona(zona.idzona))
        props.actualizarZonas()
        handleCerrarModalHabilitarZona()
    }
    //obtenerInfoDelInspector
    const getInfoInspector = (idInspector) => {
        let inspectores = ''
        props.zona.zona.zonasinspector.forEach(i => {
            inspectores = ' ' + i.inspector.titulo + '. ' + i.inspector.apellidos + ' ' + i.inspector.nombre
        })
        if (props.zona.zona.zonasinspector.length > 0) {
            props.zona.zona.zonasinspector.forEach(i => {
                inspectores = ' ' + i.inspector.titulo + '. ' + i.inspector.apellidos + ' ' + i.inspector.nombre
            })
        } else {
            inspectores = 'Pendiente de asignación'
        }

        return inspectores

    }

    //LOCALIDADES
    const [localidadModify, setLocalidadModify] = React.useState(null)

    const [modalAnadirLocalidad, setOpenModalAnadirLocalidad] = React.useState(false);
    const handleOpenModalAnadirLocalidad = () => setOpenModalAnadirLocalidad(true);

    const handleCloseModalAnadirLocalidad = () => {
        setOpenModalAnadirLocalidad(false);
        setLocalidadModify(null)
    }

    const handleEditarLocalidad = (localidad) => {
        handleOpenModalAnadirLocalidad()
        setLocalidadModify(localidad)
        props.actualizarZonas()
    }

    React.useEffect(() => {
        localidadModify
    }, [localidadModify])


    //FINALIZA LOCALIDADES

    const style = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 1100, bgcolor: 'background.paper',
        border: '2px solid #000', boxShadow: 24, p: 4, overflow: 'scroll', height: '90%',
    };

    const styleModalConfirmacion = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        width: 500, bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24,
        p: 4, fontSize: '20px', textAlign: 'center'
    };

    const HTMLmodalAnadirLocalidades = () => {
        return (
            <Modal
                open={modalAnadirLocalidad}
                onClose={handleCloseModalAnadirLocalidad}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description" >
                <Box sx={style}>

                    <LocalidadFormComponent localidadModify={localidadModify} actualizarZonas={props.actualizarZonas} onClose={handleCloseModalAnadirLocalidad} zona={zona}></LocalidadFormComponent>
                </Box>
            </Modal >
        )
    }

    const HTMLmodalVerLocalidades = () => {
        return (
            <Modal
                open={false}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description" >
                <Box sx={style}>
                    <LocalidadesDeLaZonaComponent onEditarLocalidad={handleEditarLocalidad}
                        onAnadirLocalidad={handleOpenModalAnadirLocalidad}
                        localidadModify={localidadModify}
                        handleClose={handleClose}
                        key={props.zona.zona.idzona}
                        zona={props.zona.zona}
                        localidades={localidades}
                        sublocalidades={sublocalidades}
                        actualizarZonas={props.actualizarZonas}
                    ></LocalidadesDeLaZonaComponent>
                </Box>
            </Modal >
        )
    }

    const HTMLmodalBorrarZona = () => {
        return (
            <Modal
                open={modalBorrarZona}
                onClose={handleCerrarModalBorrarZona}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={styleModalConfirmacion} >
                    <h3>Borrar Zona</h3>
                    Estás seguro de querer borrar esta zona? <br></br>
                    <button onClick={() => borrarZona(id)} className='btn btn-danger'>Si, estoy seguro</button>
                </Box>

            </Modal>
        )
    }

    const HTMLmodalHabilitarZona = () => {
        return (
            <Modal
                open={modalHabilitarZona}
                onClose={handleCerrarModalHabilitarZona}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={styleModalConfirmacion} >
                    <h3>Habilitar Zona</h3>
                    Estás seguro de querer habilitar esta zona? <br></br>
                    <button onClick={() => activarZona(id)} className='btn btn-danger'>Si, estoy seguro</button>
                </Box>

            </Modal>
        )
    }

    const HTMLmodalVerAsociados = () => {
        return (
            <Modal
                open={false}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description" >
                <Box sx={style}>
                    <LocalidadesDeLaZonaComponent onEditarLocalidad={handleEditarLocalidad}
                        onAnadirLocalidad={handleOpenModalAnadirLocalidad}
                        localidadModify={localidadModify}
                        handleClose={handleClose}
                        key={props.zona.zona.idzona}
                        zona={props.zona.zona}
                        localidades={localidades}
                        sublocalidades={sublocalidades}
                        actualizarZonas={props.actualizarZonas}
                    ></LocalidadesDeLaZonaComponent>
                </Box>
            </Modal >
        )
    }

    const modalVerAsociados = () => {
        return (
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description" >
                <Box sx={style}>
                    <AsociadosDeLaLocalidadComponent zona={zona} actualizarZonas={props.actualizarZonas}></AsociadosDeLaLocalidadComponent>
                </Box>
            </Modal >
        )
    }


    return (

        <div className='row'>
            <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mt-3`}>
                <div scope="row" className={`${estilos.zoom}`} >
                    <div className={`alert ${colorZonaByTipo(props.zona.zona.tipozona)} ${estilos.alertItem}`} style={props.zona.zona.isactivo == false ? {backgroundColor: "#FC5C5C"} : {}} role="alert" >
                        <div className='row'>
                            <div className='col-md-8 mt-3'>
                                {/* <h5>{props.zona.idzona}</h5> */}
                                <h5><strong>{props.zona.zona.nombrezona}</strong></h5>
                                <p>
                                    {/*{props.zona.zona.tipozona}<strong>Periodo: {props.zona.periodozona.fechainicio} - {props.zona.periodozona.fechafin}</strong>*/}
                                    {/* <strong>Intervalo del Periodo </strong> <br /> */}
                                    {/* <strong>Inspector:</strong>{getInfoInspector()} */}
                                </p>

                            </div>
                            <div className='col-md-4 mt-1' style={{ textAlign: 'left' }}>
                                {
                                    props.zona.zona.isactivo ?
                                        <Fragment>

                                            <button onClick={handleOpen} className={`${estilos.botonItemZona} ${estilos.zoom2} text-wrap text-center`}><FontAwesomeIcon className='mb-3' style={{ transform: 'scale(2.5)' }} icon={faPerson} /><br />Ver Instalaciones por asociado</button>

                                            <button onClick={() => props.handleEditarZona(props.zona.zona)} className={`${estilos.botonItemZona} ${estilos.zoom2} text-wrap text-center`}><FontAwesomeIcon className='mb-3' style={{ transform: 'scale(2.5)' }} icon={faPen} /><br />Editar</button>
                                            <button onClick={() => handleAbrirModalBorrarZona()} className={`${estilos.botonItemZona} ${estilos.zoom2} text-wrap text-center`}><FontAwesomeIcon className='mb-3' style={{ transform: 'scale(2.5)' }} icon={faTrash} /><br />Eliminar</button>
                                        </Fragment>
                                        :
                                        <Fragment>
                                            <button onClick={() => handleAbrirModalHabilitarZona()} className={`${estilos.botonItemZona} ${estilos.zoom2} text-wrap text-center`}><FontAwesomeIcon className='mb-3' style={{ transform: 'scale(2.5)' }} icon={faCheck} /><br />Habilitar</button>
                                        </Fragment>
                                }
                                {/* <button onClick={handleOpenModalAnadirLocalidad} className='badge bg-success'>Añadir Localidad</button> */}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {HTMLmodalAnadirLocalidades()}
            {HTMLmodalVerLocalidades()}
            {HTMLmodalBorrarZona()}
            {HTMLmodalVerAsociados()}
            {modalVerAsociados()}
            {HTMLmodalHabilitarZona()}
        </div>
    );
};


export default withRouter(ZonasListItemComponent)
